import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "../../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  useEffect(() => {
    let alive = true;
    const check = async () => {
      try {
        const r = await api.get("/auth/me");
        if (alive) setUser(r.data);
      } catch {
        try {
          await api.post("/auth/refresh");
          const r = await api.get("/auth/me");
          if (alive) setUser(r.data);
        } catch {
          if (alive) setUser(false);
        }
      }
    };
    check();
    return () => { alive = false; };
  }, []);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };
  return <AuthCtx.Provider value={{ user, setUser, logout }}>{children}</AuthCtx.Provider>;
}

export function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="grid min-h-screen place-items-center text-slate-500">Chargement…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
